const getCanonical = (siteURL, currentPageSlug, canonicalOverride) => {
  let result = siteURL

  if (canonicalOverride) {
    /*
     * We'll assume that if a relative path is given, it means
     * the user wants the full site URL prepended. Otherwise, return
     * whatever they gave to us since it is probably a full URL or a mistake.
     */
    if (canonicalOverride.charAt(0) !== '/') {
      return canonicalOverride
    }

    result += canonicalOverride
  } else if (currentPageSlug !== '/') {
    // We do not want the trailing slash added for the root path
    result += currentPageSlug
  }

  return result
}

export default getCanonical
